// cspell:ignore Catalight
import { CatalightGoalStatus } from "@api/graphql/types-and-hooks";

const CATALIGHT_GOAL_STATUS_OPTIONS = [
  { id: CatalightGoalStatus.NewGoal, primary: "New Goal" },
  { id: CatalightGoalStatus.Continued, primary: "Continued" },
  { id: CatalightGoalStatus.Revised, primary: "Revised" },
  { id: CatalightGoalStatus.Discontinued, primary: "Discontinued" },
  { id: CatalightGoalStatus.OnHold, primary: "On Hold" },
  { id: CatalightGoalStatus.Met, primary: "Met" },
];
// did not use direct enum values because of order issue in select options
export const CATALIGHT_GOAL_STATUS_SELECT_OPTIONS = CATALIGHT_GOAL_STATUS_OPTIONS.map((item) => ({
  id: item.id,
  label: item.id === CatalightGoalStatus.NewGoal ? "New" : item.primary,
}));

// Goal Attainment Scale Score options
export const GAS_SCORE_OPTIONS = [
  {
    id: "New Goal",
    primary: "New Goal",
  },
  {
    id: "0 - No Progress within Reporting Period - Not Met",
    primary: "0 - No Progress within Reporting Period - Not Met",
  },
  {
    id: "1 - Some Progress within Reporting Period - Not Met",
    primary: "1 - Some Progress within Reporting Period - Not Met",
  },
  { id: "2 - Expected outcome - Goal Met", primary: "2 - Expected outcome - Goal Met" },
  {
    id: "3 - Somewhat more than expected outcome - Goal Met",
    primary: "3 - Somewhat more than expected outcome - Goal Met",
  },
  { id: "4 - Much more than expected outcome - Goal Met", primary: "4 - Much more than expected outcome - Goal Met" },
];

export const statusMap = Object.values(CatalightGoalStatus).reduce(
  (acc, value) => {
    acc[value] = value;
    return acc;
  },
  {} as Record<CatalightGoalStatus, CatalightGoalStatus>,
);
